//the below event is fired on view cart page
"use client";
import { CURRENCY_CODE } from "@/lib/constant";
import { sendGTMEvent } from "@next/third-parties/google";
import { formatItems } from "@repo/lib/helpers";
import { useEffect, useRef } from "react";

const GTMViewCart = ({ cart }) => {
  const preventExtraCallRef = useRef(false);
  useEffect(() => {
    if (cart?.lineItems?.length && !preventExtraCallRef.current) {
      const { cartTotal, lineItems, couponName } = cart;
      preventExtraCallRef.current = true;
      sendGTMEvent({
        event: "view_cart",
        currency: CURRENCY_CODE,
        value: cartTotal?.total,
        items: formatItems(lineItems, couponName),
      });
    }
  }, [cart]);

  return null;
};

export default GTMViewCart;
